import { Box, Stack, Typography } from '@mui/material';

export default function PageHeader({ title, subtitle, action }) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      gap={2}
      mb={2}
      sx={{ width: '100%' }}
    >
      <Box>
        <Typography variant="h5">{title}</Typography>
        {subtitle && <Typography color="text.secondary">{subtitle}</Typography>}
      </Box>
      {action && (
        <Box sx={{ ml: { sm: 'auto' }, mb: '5px', alignSelf: { xs: 'flex-end', sm: 'center' } }}>
          {action}
        </Box>
      )}
    </Stack>
  );
}
